import api from "./api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

const _isDefaultFilterOptions = (opts) => {
    if (!opts || typeof opts !== 'object') return true;
    const filters = opts.filters;
    const hasFilterValues = filters && typeof filters === 'object'
        && Object.values(filters).some((v) => Array.isArray(v) ? v.length > 0 : Boolean(v));
    if (hasFilterValues) return false;
    if (opts.search) return false;
    return true;
};

export const getAllEventMasterlistData = async (limit, page, searchTerm, filterOptions = {}) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (!_isDefaultFilterOptions(filterOptions)) {
        const cleanedOptions = {
            ...filterOptions,
            filters: Object.fromEntries(
                Object.entries(filterOptions.filters || {}).filter(([, v]) =>
                    Array.isArray(v) ? v.length > 0 : Boolean(v)
                )
            ),
        };
        formData.append('filters', JSON.stringify(cleanedOptions));
    }

    if (searchTerm) {
        formData.append('search', searchTerm);
    }

    if (filterOptions.sortBy_v) {
        formData.append('sort_by', filterOptions.sortBy_v);
    }

    if (filterOptions.sortOrder_v) {
        formData.append('sort_order', filterOptions.sortOrder_v);
    }

    const params = new URLSearchParams(formData);

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminEventMasterlist}`, {
        params: params
    })
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getEventMasterlistBasicData = async (alias, searchTerm) => {
    const formData = new FormData();

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/general/basic`, {
        params: params
    })
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getEventMasterlistIntroductionData = async (alias, introductionSection) => {

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/introduction/${introductionSection}`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

export const updateEventMasterlistData = async (alias, payload, deletedValues = {}) => {
    const requestPayload = {
        ...payload,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}`, requestPayload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

// Screenings API functions
export const getEventScreeningsData = async (alias, page = 1, page_size = 50) => {
    const result = await api.get(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/screenings`, {
        params: { page_number: page, page_size }
    });
    if (result) {
        return result?.data;
    } else {
        return null;
    }
};

export const createEventScreeningsData = async (alias, data) => {
    const result = await api.post(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/screenings`, data);
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const updateEventScreeningsData = async (alias, data) => {
    const result = await api.put(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/screenings`, data);
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteEventScreeningsData = async (alias, deletedItems) => {
    const result = await api.delete(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/screenings`, { data: { deletedItems } });
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

// Seminars and Conferences API functions
export const getEventSeminarsData = async (alias, page = 1, page_size = 50) => {
    const result = await api.get(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/seminars`, {
        params: { page_number: page, page_size }
    });
    if (result) {
        return result?.data;
    } else {
        return null;
    }
};

export const createEventSeminarsData = async (alias, data) => {
    const result = await api.post(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/seminars`, data);
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const updateEventSeminarsData = async (alias, data) => {
    const result = await api.put(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/seminars`, data);
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteEventSeminarsData = async (alias, deletedItems) => {
    const result = await api.delete(`${APIS.BASE_URL}${APIS.adminEventMasterlist}/${alias}/bodyofwork/seminars`, { data: { deletedItems } });
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};
